import { css } from '@/styled-system/css';

export const content = css({ display: 'flex', flexDirection: 'column', gap: 'default', width: '100%', minWidth: 0 });
export const row = css({ display: 'flex', alignItems: 'center', gap: 'tighter' });
export const line = css({ height: '{spacing.default}', width: '100%' });
export const shortLine = css({ height: '{spacing.default}', width: '40%' });
export const title = css({ height: '{spacing.loose}', width: '60%' });
export const rating = css({ height: 'calc(3 * {spacing.default})', width: '25%' });
export const tabs = css({ height: 'calc(2 * {spacing.default} + {spacing.tighter})', width: '100%' });
export const card = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  padding: 'default',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  borderRadius: 'md',
});
export const panel = css({ minHeight: 'calc(20 * {spacing.default})' });
export const google = css({ minHeight: 'calc(28 * {spacing.default})' });
export const entry = css({
  display: 'flex',
  alignItems: 'center',
  paddingBlock: 'tighter',
  paddingInline: 'default',
  borderRadius: 'md',
  backgroundColor: 'bg.softest',
});
export const visuallyHidden = css({ srOnly: true });

export const webCards = css({
  display: 'flex',
  gap: 'tighter',
  overflow: 'hidden',
  '& > div': { flexShrink: 0, flexBasis: 'calc(100% - {spacing.loose})' },
  lg: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    '& > div:nth-child(n + 3)': { display: 'none' },
  },
  xl: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    '& > div:nth-child(n + 3)': { display: 'flex' },
  },
});
